import { jsx } from "react/jsx-runtime";
import { memo, forwardRef } from "react";
import { IconBase } from "src/components/ui/IconBase";
export default memo(forwardRef(function IconSvgClear({
  className,
  "data-test-id": dataTest = "IconClear",
  ...props
}, ref) {
  return /* @__PURE__ */ jsx(IconBase, { ...props, "data-test-id": dataTest, className, innerRef: ref, children: /* @__PURE__ */ jsx("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx("path", { fill: "currentColor", d: "M7.922 7L7 7.922 11.079 12 7 16.079l.92.921 4.07-4.088L16.08 17l.921-.922-4.09-4.09 4.049-4.068-.88-.92-4.078 4.079z" }) }) });
}));
